module.exports = __webpack_public_path__ + "static/media/a16.016dbd34.jpg";